import { CmsIcon } from '@/components/CmsIcon';

/** Keyword → Lucide icon name (kebab-case). Used when CMS icon field is blank. */
const KEYWORD_MAP: Record<string, string> = {
  bed:        'bed-double',
  wifi:       'wifi',
  pool:       'waves',
  beach:      'waves',
  garden:     'leaf',
  nature:     'tree-pine',
  patio:      'umbrella',
  balcony:    'sun',
  ac:         'wind',
  tv:         'tv',
  bathtub:    'bath',
  shower:     'shower-head',
  safe:       'lock-keyhole',
  fridge:     'refrigerator',
  minibar:    'wine',
  mountain:   'mountain',
  view:       'eye',
  breakfast:  'coffee',
  restaurant: 'utensils-crossed',
  gym:        'dumbbell',
  parking:    'car',
  spa:        'sparkles',
  butler:     'concierge-bell',
  lounge:     'sofa',
  default:    'sparkles',
};

function normalise(label: string): string {
  const l = label.toLowerCase();
  if (l.includes('bed') || l.includes('king') || l.includes('queen') || l.includes('twin') || l.includes('double')) return 'bed';
  if (l.includes('wi-fi') || l.includes('wifi') || l.includes('internet') || l.includes('wireless')) return 'wifi';
  if (l.includes('pool') || l.includes('swim')) return 'pool';
  if (l.includes('beach') || l.includes('ocean') || l.includes('sea') || l.includes('wave')) return 'beach';
  if (l.includes('garden') || l.includes('lawn') || l.includes('green')) return 'garden';
  if (l.includes('forest') || l.includes('tree') || l.includes('jungle')) return 'nature';
  if (l.includes('patio') || l.includes('outdoor') || l.includes('terrace')) return 'patio';
  if (l.includes('balcony') || l.includes('deck') || l.includes('veranda')) return 'balcony';
  if (l.includes('air con') || l.includes(' ac ') || l.includes('a/c') || l.includes('cooling')) return 'ac';
  if (l.includes('tv') || l.includes('television') || l.includes('screen')) return 'tv';
  if (l.includes('bathtub') || l.includes('jacuzzi') || l.includes('tub') || l.includes('soaking')) return 'bathtub';
  if (l.includes('shower') || l.includes('bathroom') || l.includes('bath')) return 'shower';
  if (l.includes('safe') || l.includes('locker') || l.includes('vault')) return 'safe';
  if (l.includes('fridge') || l.includes('refrigerator') || l.includes('freezer')) return 'fridge';
  if (l.includes('mini') || l.includes('bar') || l.includes('wine') || l.includes('drink') || l.includes('welcome')) return 'minibar';
  if (l.includes('mountain') || l.includes('valley') || l.includes('hill')) return 'mountain';
  if (l.includes('view') || l.includes('panoram') || l.includes('scenic')) return 'view';
  if (l.includes('breakfast') || l.includes('coffee') || l.includes('tea') || l.includes('meal')) return 'breakfast';
  if (l.includes('restaurant') || l.includes('kitchen') || l.includes('dining') || l.includes('food')) return 'restaurant';
  if (l.includes('gym') || l.includes('fitness') || l.includes('workout')) return 'gym';
  if (l.includes('parking') || l.includes('car') || l.includes('vehicle') || l.includes('garage')) return 'parking';
  if (l.includes('spa') || l.includes('massage') || l.includes('wellness') || l.includes('sauna')) return 'spa';
  if (l.includes('butler') || l.includes('concierge') || l.includes('service') || l.includes('bell')) return 'butler';
  if (l.includes('lounge') || l.includes('sofa') || l.includes('living') || l.includes('sitting')) return 'lounge';
  if (l.includes('checkout') || l.includes('check-out') || l.includes('late')) return 'clock';
  return 'default';
}

export function AmenityIcon({
  label,
  icon,
  size = 22,
  className,
}: {
  label: string;
  icon?: string | null;
  size?: number;
  className?: string;
}) {
  if (icon) {
    return <CmsIcon name={icon} size={size} className={className} />;
  }
  const fallbackName = KEYWORD_MAP[normalise(label)] ?? KEYWORD_MAP.default;
  return <CmsIcon name={fallbackName} size={size} className={className} />;
}
